import axiosInstance from "./axiosInstance";

export const getBlogs = async () => {
  try {
    const response = await axiosInstance.get("/public/blog", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch blogs");
  }
};

export const getBlogById = async (id) => {
  try {
    const response = await axiosInstance.get(`/public/blogfetch/${id}`, {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch blog");
  }
};

export const createBlog = async (formData) => {
  try {
    const response = await axiosInstance.post("/blog/save", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to create blog");
  }
};

export const updateBlog = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`/update/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authType: "PostLogin",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to update blog");
  }
};

export const deleteBlog = async (id) => {
  try {
    const response = await axiosInstance.delete(`/blogdel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete blog");
  }

};

export const getPlanTypes = async () => {
  try {
    const response = await axiosInstance.get("/category", {
      headers: { authType: "PreLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch plan types");
  }

};